import React from 'react';
import { Table as BTable } from 'react-bootstrap';
import { flexRender, HeaderGroup, Row } from '@tanstack/react-table';
import { CertificateDataEntry } from './CertificateRisk/CertificateRisk';
import { Code95CycleDataEntry } from './Code95Cycle/Code95Cycle';
import { DrivingLicenseDataEntry } from './DrivingLicense/DrivingLicense';
import { DrivingPassDataEntry } from './DrivingPass/DrivingPass';
import { useNavigate } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';

type Props = {
	headerGroups:
		| HeaderGroup<CertificateDataEntry>[]
		| HeaderGroup<Code95CycleDataEntry>[]
		| HeaderGroup<DrivingLicenseDataEntry>[]
		| HeaderGroup<DrivingPassDataEntry>[];
	rows: Row<
		CertificateDataEntry | Code95CycleDataEntry | DrivingLicenseDataEntry | DrivingPassDataEntry
	>[];
};

export interface StudentDataEntry {
	id: number;
}

const DashboardTable = ({ headerGroups, rows }: Props) => {
	const navigate = useNavigate();
	return (
		<BTable responsive hover size={'l'}>
			<thead>
				{headerGroups.map((headerGroup) => (
					<tr key={headerGroup.id}>
						{headerGroup.headers.map((header) => (
							<th key={header.id}>
								{header.isPlaceholder ? null : (
									<div
										className={header.column.getCanSort() ? 'cursor-pointer select-none' : ''}
										onClick={header.column.getToggleSortingHandler()}
										title={
											header.column.getCanSort()
												? header.column.getNextSortingOrder() === 'asc'
													? 'Sort ascending'
													: header.column.getNextSortingOrder() === 'desc'
														? 'Sort descending'
														: 'Clear sort'
												: undefined
										}>
										{/*@ts-ignore */}
										{flexRender(header.column.columnDef.header, header.getContext())}
										{{
											asc: <span className="ms-1 glyphicons-arrow-thin-down arrow-sorted" />,
											desc: <span className="glyphicons-arrow-thin-up arrow-sorted" />,
										}[header.column.getIsSorted() as string] ?? null}
									</div>
								)}
							</th>
						))}
					</tr>
				))}
			</thead>
			<tbody>
				{rows.map((row) => {
					return (
						<tr
							key={row.id}
							className="cursor-pointer"
							onClick={() => navigate(ROUTES.employeeDetailPage(row.original.id))}>
							{row.getVisibleCells().map((cell) => (
								<td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
							))}
						</tr>
					);
				})}
			</tbody>
		</BTable>
	);
};

export default DashboardTable;
